import Position from "./Position";
import User from "./User";
import WorkPermitTag from "./WorkPermitTag";
import { MaritimeEventType } from "../common/enums";

type WorkPermit = {
    id: number;
    documentReferenceId: string;
    sequenceIdentifier: string;
    status: string;
    displayStatus: string;
    description: string;
    permitName: string;
    startDate: Date;
    endDate: Date;
    positions: Position[];
    permitCategory: string;
    department: string;
    version: number;
    displaySequenceId: string;
    hasAttachedFiles: boolean;
    isColdWorkOnly: boolean;
    entrepreneur: string;
    isActive: boolean;
    workPermitTags: WorkPermitTag[];
    user: User;
    isAnonymousPermit: boolean;
    hasReducedInfo: boolean;
    maritimeEventType?: MaritimeEventType
};

export const permitContentVersions = {
    /** The version of all permits created before content versions were introduced. */
    initial: 0,
    /**
     * This version introduced changes to the following checklists used in the EnergyHarbourPermit and GeneralDepartmentPermit:
     * WorkAtHeightChecklist, ClosedSpaceChecklist, AsbestosChecklist, HydrogenSulphideChecklist, BeefGasChecklist,
     * HeavyLiftingChecklist, ExcavationAndPolingChecklist, ElectricDisconnectionChecklist, ElectricFenceChecklist, Take2Checklist.
     * For the changes made in each checklist, see the respective checklist class.
     *
     * The ScaffoldingChecklist was removed and replaced with two new checklists: ScaffoldingConstructionChecklist and ScaffoldingWorkChecklist.
     *
     * WorkOnRoadChecklist and ConstructionPowerChecklist were added.
     */
    version_2026_02: 1,
    /** Introduced changes to the options in the HotWorkCategoryTwo section of the EnergyHarbourPermit. For details on the changes, see the HotWorkCategoryTwoOptions class. */
    version_2026_03: 2,
    /**
     * This version adds support for three new features for EnergyHarbourPermits: Multiple categories on the same permit, per position categories,
     * and hot work conditions specific to each of the hot work categories.
     *
     * It also changed the permit names of the DivingPermit (Dyktillstånd -> Dyktillstånd/Undervattensarbete) and
     * UnderWaterWorkPermit (Tillstånd för undervattensarbete samt arbete från flotte -> Tillstånd för arbete från flotte/pråm).
     */
    version_2026_04: 3,
    /**
     * After this version, the cold work category is always included in the permit categories of EnergyHarbourPermits.
     * The category is selected by default and cannot be removed. This is to make sure that all position categories,
     * that are limited by the categories selected on the permit level, can be set to ColdWork if needed.
     */
    version_2026_04_22: 4,
    /** Adds support for specifying which EnergyHarbour customer ordered the work when OrderedBy is Other. */
    version_2026_05: 5
} as const;

export default WorkPermit;
